import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
        name: 'appfUppercase'
})
export class UppercasePipe implements PipeTransform {
    transform(value: string) {
        return value.toUpperCase();
    }
}



// WEBPACK FOOTER //
// /Volumes/Projects/dev2/ng2fb-bootstrap/src/app/shared/pipes/uppercase.pipe.ts